import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withFirebase } from '../Firebase';


const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
});


class AdminPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      users: [],
    }
  };

  componentDidMount() {
    this.setState({ loading: true });

    this.props.firebase.users().on('value', snapshot => {
      const usersObject = snapshot.val();

      const usersList = Object.keys(usersObject).map(key => ({
        ...usersObject[key],
        uid: key,
      }))

      this.setState({
        users: usersList,
        loading: false
      });
    });
  }

  componentWillUnmount() {
    this.props.firebase.users().off();
  }

  render() {

    const { users, loading } = this.state;
   

    return (
      <div>
        <h1>Admin</h1>

      {loading && <div>Loading ...</div>}

      <UserList users={users} />

      </div>
    );
  }
}

const UserList = ({ users }) => (


  <TableContainer component={Paper}>
    <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Username</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {users.map(user => (
          <TableRow key={user.uid}>
            <TableCell component="th" scope="row">
              {user.uid}
            </TableCell>   
            <TableCell component="th" scope="row">
            {user.email}
            </TableCell>  
            <TableCell component="th" scope="row">
            {user.username}
            </TableCell>      
          </TableRow>
        ))}
        </TableBody>
    </Table>
  </TableContainer>
 
)

export default withFirebase(AdminPage);